import { useMemo } from "react";
import { Box } from "@chakra-ui/layout";
import { formatCurrency } from "@brazilian-utils/brazilian-utils";
import { EntradaAcordo } from "core/features/acordo/typings";

function useListagemEntradaAcordoColumns() {
  return useMemo(() => {
    return [
      {
        title: "Entrada",
        render: (original: EntradaAcordo) => (
          <Box>R$ {formatCurrency(original.valor || 0)}</Box>
        ),
      },
      {
        title: "Meio de Pagamento",
        render: (original: EntradaAcordo) => (
          <Box>{original.formaPagamento?.nome}</Box>
        ),
      },
    ];
  }, []);
}

export default useListagemEntradaAcordoColumns;
